module.exports = __webpack_public_path__ + "static/media/icon-2.0f703118.png";